// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__TYe0i","header":"style_header__WVfNa","footer":"style_footer__RovW3"};